import { render, staticRenderFns } from "./AdminUserBalanceDeposit.vue?vue&type=template&id=4ee39e36&scoped=true&"
import script from "./AdminUserBalanceDeposit.vue?vue&type=script&lang=ts&"
export * from "./AdminUserBalanceDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUserBalanceDeposit.vue?vue&type=style&index=0&id=4ee39e36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee39e36",
  null
  
)

export default component.exports